module.exports = __webpack_public_path__ + "static/img/result_ceil_lx_angle.39ee057.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ceil_lx_angle.jpg
// module id = hRv+
// module chunks = 3